import { AbstractControl, FormGroup, ValidationErrors, ValidatorFn } from "@angular/forms";
import { phoneReFormat } from "../../utils/helper";
import { phoneRegexWithFormat } from "../../utils/constants";

export function customValidatorForPhoneList(controlType: 'MOBILE' | 'HOME1' | 'OFFICE1'): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const errors: ValidationErrors = {};
  
      if (control.parent instanceof FormGroup) {
        const phoneTypeControl = control.parent.controls['preferred'];
        if (phoneTypeControl && phoneTypeControl.value === controlType) {
            if (!control.value) {
                errors["required"] = true;  // If no value is entered, return an error
                return errors;
            }
    
            // Validate the phone number format (removes non-numeric characters and tests with regex)
            if (!phoneRegexWithFormat.test(control.value.replace(/\D/g, ''))) {
                errors["pattern"] = true;  // If the phone number doesn't match the regex, return pattern error
                return errors;
            }
        
            return null;  // No errors, valid input
        }
      }  
      return null;  // No errors, valid input
    }
  }
  export function customPhoneValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      if (control.value) {
        const number = control.value.replace(/\s/g, "");  // Remove spaces
      
        // If the phone number doesn't match the regex or has an invalid length, return error
        if (!phoneRegexWithFormat.test(control.value) || (number.length > 0 && phoneReFormat(number).length != 10)) {
          return {'pattern': true};
        }
      }
      return null;  // No errors, valid input
    }
  }
  